import { LabTechsQuery, useLabTechsQuery } from 'schema'
import { createStrictContext } from 'utils/createContext'
import { DefaultQueryHookOptions } from 'utils/defaults'
import { useProjectContext } from 'context/ProjectContext'

export type LabTech = LabTechsQuery['project']['labTechs'][0]

type LabTechsContext = Pick<ReturnType<typeof useLabTechsQuery>, 'refetch'> & {
  fetching?: boolean
  labTechs?: LabTech[]
}

const { useContextFn, Provider } =
  createStrictContext<LabTechsContext>('LabTechsContext')

export const useLabTechsContext = useContextFn
const LabTechsProvider: React.FC = ({ children }) => {
  const { projectId } = useProjectContext()
  const {
    data,
    loading: fetching,
    refetch,
  } = useLabTechsQuery({
    ...DefaultQueryHookOptions,
    variables: { projectId },
  })
  return (
    <Provider
      value={{
        refetch,
        fetching,
        labTechs: data?.project?.labTechs,
      }}
    >
      {children}
    </Provider>
  )
}

export default LabTechsProvider
